import React from 'react'
import { Navigate } from 'react-router-dom'
import { SIGN_IN_PATH } from 'routes/constants.routes'
import { HomeStoreProvider } from 'context/HomeStore'
import { ContractStoreProvider } from 'context/ContractStore'
import { useAuthStore } from 'context/AuthStore'
import { ErrorBoundary } from 'asterX-UI'

const getProviders = (element, pageType) => {
  if (['new-application', 'application', 'contract', 'client', 'collateral'].includes(pageType)) {
    return <ContractStoreProvider key="contract">{element}</ContractStoreProvider>
  }

  return <HomeStoreProvider key="home">{element}</HomeStoreProvider>
}

const PrivateRoute = ({ element, pageType }) => {
  const { authStore } = useAuthStore()

  if (!authStore.isLoggedIn) {
    return <Navigate to={SIGN_IN_PATH} replace />
  }

  return <ErrorBoundary>{getProviders(element, pageType)}</ErrorBoundary>
}

export default PrivateRoute
